/**
 * @license
 * Powered by MaxDesign. All Rights Reserved.
 * ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
 * ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 */

if (!customElements.get('delivery-estimation-maxdesign')) {
  class DeliveryEstimation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
        this.placeholder = this.querySelector('[data-delivery-estimation]');
        this.renderResult(this.getDays());
        if (this.settings.geoFlagEnable && this.settings.geoFlagAPI != '') this.geoFlag();
      }, 1);
    }

    renderResult({ dayMin, monthMin, dayMax, monthMax }) {
      const deliveryText = this.placeholder.innerHTML;
      this.placeholder.innerHTML = deliveryText
        .replace('[dayMin]', dayMin)
        .replace('[dayMax]', dayMax)
        .replace('[monthMin]', monthMin === monthMax ? '' : monthMin)
        .replace('[monthMax]', monthMax);
    }

    getDays() {
      const deliveryTag = this.placeholder.dataset.deliveryEstimation;
      const monthNames = this.settings.monthNames.split(',');
      var dayMin = this.settings[deliveryTag].min,
        dayMax = this.settings[deliveryTag].max,
        endDateMin = '',
        monthMin = '',
        daysToAddMin = dayMin,
        countMin = 0,
        todayMin = new Date(),
        endDateMax = '',
        monthMax = '',
        daysToAddMax = dayMax,
        countMax = 0,
        todayMax = new Date();

      // get dayMin & monthMin
      while (countMin < daysToAddMin) {
        endDateMin = new Date(todayMin.setDate(todayMin.getDate() + 1));
        dayMin = endDateMin.getDate();
        monthMin = monthNames[endDateMin.getMonth()];
        if (endDateMin.getDay() != 0 && this.checkHolidays(endDateMin)) countMin++;
      }

      // get dayMax & monthMax
      while (countMax < daysToAddMax) {
        endDateMax = new Date(todayMax.setDate(todayMax.getDate() + 1));
        dayMax = endDateMax.getDate();
        monthMax = monthNames[endDateMax.getMonth()];
        if (endDateMax.getDay() != 0 && this.checkHolidays(endDateMax)) countMax++;
      }

      // return daya to render
      return {
        dayMin,
        monthMin,
        dayMax,
        monthMax,
      };
    }

    /**
     * check whether  holiday match
     * @param {Date} dateIncrement
     * @returns {Boolean}
     */
    checkHolidays(dateIncrement) {
      for (const [index, i] of Object.entries(this.settings.holidays))
        if (i[0] == dateIncrement.getDate() && i[1] == dateIncrement.getMonth() + 1) return;
      return true;
    }

    geoFlag() {
      fetch(`https://api.ipdata.co/?api-key=${this.settings.geoFlagAPI}`)
        .then(response => response.json())
        .then(geoData => {
          if (this.settings.geoFlagCountries.includes(geoData.country_code))
            this.querySelector('[data-delivery-flag]').innerHTML = `<img src="${geoData.flag}">`;
        })
        .catch(console.error);
    }
  }
  customElements.define('delivery-estimation-maxdesign', DeliveryEstimation);
}
